import GlobalStyles from '@mui/material/GlobalStyles';

import { WELCOME_VIEW_TRANSITION_TYPE } from 'router/viewTransitions';

import { BUSINESS_TYPE_OPTION_CARD_VIEW_TRANSITION_CLASS } from './viewTransitions';

const TRANSITION_DURATION_MS = 250;
/** Hard-copied from open-props `--ease-5` — see ADR-018 "FEEL". */
const TRANSITION_EASING = 'cubic-bezier(.25, 0, .1, 1)';

const { card, illustration, typeHeader } =
  BUSINESS_TYPE_OPTION_CARD_VIEW_TRANSITION_CLASS;
const { backward } = WELCOME_VIEW_TRANSITION_TYPE;

export function WelcomeViewTransitionStyles() {
  return (
    <GlobalStyles
      styles={theme => `
        ::view-transition-group(.${card}),
        ::view-transition-group(.${illustration}),
        ::view-transition-group(.${typeHeader}),
        ::view-transition-old(.${card}),
        ::view-transition-new(.${card}),
        ::view-transition-old(.${illustration}),
        ::view-transition-new(.${illustration}),
        ::view-transition-old(.${typeHeader}),
        ::view-transition-new(.${typeHeader}) {
          animation-duration: ${TRANSITION_DURATION_MS}ms;
          animation-timing-function: ${TRANSITION_EASING};
        }

        ::view-transition-group(.${illustration}) {
          z-index: 1;
          /* The live img is square: ImagePreview rounds a wrapper figure via
             overflow, and snapshots escape ancestor clipping. Re-clip here. */
          border-radius: ${theme.border.radius.regular}px;
          overflow: clip;
        }
        ::view-transition-group(.${typeHeader}) {
          z-index: 2;
        }
        html:active-view-transition-type(${backward})::view-transition-new(.${card}) {
          animation: none;
          mix-blend-mode: normal;
        }
        html:active-view-transition-type(${backward})::view-transition-old(.${card}) {
          animation: none;
          opacity: 0;
          mix-blend-mode: normal;
        }
        html:active-view-transition-type(${backward})::view-transition-image-pair(.${card}) {
          isolation: auto;
        }
      `}
    />
  );
}
